import React from 'react';
import image1 from '../../../Assets/Cards/marketing.webp';
import Card from './Card';
import { booksData } from './data';
import './Styles/Cards.scss';
const Cards=({postsToRender})=>{
    return(
        <div className="ebooks-cards">
            {postsToRender.map((item) =>{
                return(

                    <Card 
                    image={item.image}
                    title={item.title}
                    desc={item.desc}
                    />
                )
            })}
        </div>
    )
};
export default Cards ;